module.exports = {
    optBlueOptions: {
        none: 0,
        err: 1,
        tiered: 2,
        interchange: 3
    },
    pricingTypes: {
        err: 'ERR',
        tiered: 'Tiered',
        interchange: 'Interchange'
    },
    formInputLabelTypes: {
        boolean: 'boolean',
        date: 'date',
        number: 'number',
        phone: 'phone',
        string: 'string'
    },
    cforceDepartments: {
        EXTERNAL_AGENT_DEPARTMENT: 2,
        ADMIN_DEPARTMENT: 10,
        PRODUCT_DEVELOPMENT_DEPARTMENT: 11,
        UNDERWRITING_DEPARTMENT: 13,
        PARTNERSHIPS_DEPARTMENT: 25,
        EXTERNAL_PARTNER_DEPARTMENT: 29
    },
    cforceNotifications: {
        EDIT_MERCHANT: 1,
        ADD_MERCHANT: 9
    },
    giactResponse: {
        12: {
            verificationResponse: 'Pass',
            code: '_1111',
            description:  'Account Verified – The account was found to be an open and valid account.'
        },
        13: {
            verificationResponse: 'Pass',
            code: '_2222',
            description: 'AMEX Cheque – The account was found to be an open and valid American Express account.'
        },
        14: {
            verificationResponse: 'Pass',
            code: '_3333',
            description: 'Non‐Participant Provider – This account was reported with acceptable, positive data found in current or recent transactions.'
        },
        15: {
            verificationResponse: 'Pass',
            code: '_5555',
            description: 'Savings Account Verified – The account was found to be an open and valid account.'
        },
        21: {
            verificationResponse: 'No Data',
            code: 'ND00',
            description: 'No positive or negative information has been reported on the account. This could be a small or regional bank that does not report.'
        },
        22: {
            verificationResponse: 'No Data',
            code: 'ND01',
            description: 'No positive or negative information has been reported on the account. This routing number can only be valid for US Government financial institutions. Please verify this item with its issuing authority.'
        },
        1: {
            verificationResponse: 'Declined',
            code: 'GS01',
            description: 'Invalid Routing Number - The routing number supplied did not match the format of a valid routing number.'
        },
        2: {
            verificationResponse: 'Declined',
            code: 'GS02',
            description: 'Invalid Account Number ‐ The account number supplied did not match the format of a valid account number.'
        },
        3: {
            verificationResponse: 'Declined',
            code: 'GS03',
            description: 'Invalid Check Number ‐ The check number supplied did not match the format of a valid check number.'
        },
        4: {
            verificationResponse: 'Declined',
            code: 'GS04',
            description: 'Invalid Amount ‐ The amount supplied did not match the format of a valid amount.'
        },
        20: {
            verificationResponse: 'Unassigned Routing Number',
            code: 'GN05',
            description: 'Unassigned Routing Number ‐ The routing number supplied is reported as not assigned to a financial institution.'
        },
        5: {
            verificationResponse: 'Private Bad Checks List',
            code: 'GP01',
            description: 'Private Bad Checks List – Variable - The value for Details will vary depending on the value set for CheckReject reason in the Private Bad Checks List.'
        },
        6: {
            verificationResponse: 'Declined',
            code: 'RT00',
            description: 'No Information Found - The routing number appears to be accurate however no positive or negative information has been reported on the account. ' +
                'Please contact customer to ensure that the correct account information was entered.'
        },
        7: {
            verificationResponse: 'Declined',
            code: 'RT01',
            description: 'Declined - This account should be returned based on the risk factor being reported.'
        },
        8: {
            verificationResponse: 'Reject Item',
            code: 'RT02',
            description: 'Reject Item ‐ This item should be rejected based on the risk factor being reported.'
        },
        9: {
            verificationResponse: 'Accept With Risk',
            code: 'RT03',
            description: 'Accept With Risk - Current negative data exists on this account. Accept transaction with risk. (Example: Checking or savings accounts in NSF status, recent returns, or outstanding items)'
        },
        10: {
            verificationResponse: 'Pass Non Demand Deposit',
            code: 'RT04',
            description: 'Non Demand Deposit Account ‐ This is a Non Demand Deposit Account (post no debits), Credit Card Check, Line of Credit, Home Equity or a Brokerage check.'
        },
        19: {
            verificationResponse: 'Negative Data',
            code: 'GN01',
            description: 'Negative Data ‐ Negative information was found.'
        }
    }
};
